<template>
  <div class="form-group">
    <label :for="compId">{{ $t(i18nLabel) }}&nbsp;<abbr :title="$t('common.form.required')" v-if="isRequired()"><sup>*</sup></abbr></label>
    <input :type="type" :id="compId" :value="modelValue || ''" @input="onChange($event.target.value)" v-bind:class="{ 'form-error-focusable': validation.$error }" class="form-control" />
    <control-error-message :validation="validation" :i18nLabel="i18nLabel" />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import _uniqueId from 'lodash.uniqueid'
import ControlErrorMessage from './ControlErrorMessage.vue';
import { Validation } from '@vuelidate/core';

export default defineComponent({
  components: { ControlErrorMessage },
  name: 'ControlInput',
  props: {
    i18nLabel: { type: String, required: true },
    validation: { type: Object as PropType<Validation>, required: true },
    modelValue: { type: String },
    type: { type: String, required: false, default: 'text' }
  },
  data() {
    return {
      compId: _uniqueId('control-input-')
    }
  },
  methods: {
    isRequired() {
      return !!this.validation.required
    },
    onChange(val: string) {
      this.$emit('update:modelValue', val);
      this.validation.$touch();
    }
  }
});
</script>
